import React from 'react';
import LayoutBottomFooter from './layout.bottom-footer';
import { useSelector } from 'react-redux';
import '@fortawesome/fontawesome-free/css/all.css';
import { Link } from 'react-router-dom';

export default function LayoutFooter() {
    const wording = useSelector(({ language }) => language.wording);
    const basenameURL = useSelector(({ language }) => language.basenameURL);

    return (
        <footer className='footer footer-type-3'>
            <div className='container'>
                <div className='footer-widgets'>
                    <div className='row'>
                        <div className='col-md-8 col-sm-12 col-xs-12'>
                            <div className='widget copyright'>
                                <ul className='bottom-footer-links'>
                                    <li>
                                        <Link to={`${basenameURL}/about-us`} rel='noopener noreferrer'>
                                            {wording.homePage.footer.aboutus}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to={`${basenameURL}/branches`} rel='noopener noreferrer'>
                                            {wording.homePage.footer.branches}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to={`${basenameURL}/how-to-buy`} rel='noopener noreferrer'>
                                            {wording.homePage.footer.how}
                                        </Link>
                                    </li>
                                    <li>
                                        <a href={`https://track.thailandpost.co.th`}
                                            target='_blank'
                                            rel='noopener noreferrer'>
                                            {wording.homePage.footer.track}
                                        </a>
                                    </li>
                                </ul>
                                <span>{`© ${new Date().getFullYear()} SF Group. All rights reserved`}</span>
                            </div>
                        </div>

                        <div className='col-md-4 col-sm-12 col-xs-12'>
                            <div className='widget footer-links' align="right">
                                <ul>
                                    <li className='social-icons dark rounded'>
                                        <a
                                            href='https://www.facebook.com/SFcinema'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            className='mr-20'
                                            style={{ "--color": "#3b5999" }}>
                                            <i className='fab fa-facebook-f' style={{ color: '#FFFFFF' }} />
                                        </a>
                                    </li>
                                    <li className='social-icons dark rounded'>
                                        <a
                                            href='https://twitter.com/WeLoveSF'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            className='mr-20'
                                            style={{ "--color": "#55acee" }}>
                                            <i className='fab fa-twitter' style={{ color: '#FFFFFF' }} />
                                        </a>
                                    </li>
                                    <li className='social-icons dark rounded'>
                                        <a
                                            href='https://www.instagram.com/welove_sf'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            className='mr-20'
                                            style={{ "--color": "#e4405f" }}>
                                            <i className='fab fa-instagram' style={{ color: '#FFFFFF' }} />
                                        </a>
                                    </li>
                                    <li className='social-icons dark rounded'>
                                        <a
                                            href='https://www.youtube.com/WeLoveSF'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            className='mr-20'
                                            style={{ "--color": "#cd201f" }}>
                                            <i className='fab fa-youtube' style={{ color: '#FFFFFF' }} />
                                        </a>
                                    </li>
                                    <li className='social-icons dark rounded'>
                                        <a
                                            href='mailto:SFshop@sfcinema.com'
                                            target='_top'
                                            className='mr-20'
                                            style={{ "--color": "#165FEF" }}>
                                            <i className='fa fa-envelope' style={{ color: '#FFFFFF' }} />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <LayoutBottomFooter />
        </footer>
    );
}
